import styled from 'styled-components'

export const H1 = styled.h1 `
  color: white;
  text-align: center;
`

export const P = styled.p `
  color: white;
  text-align: center;
`

export const Div = styled.div `
  height: 100vh;
  margin-top: 7em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const GetInTouch = styled.div `
  width: 8em;
  height: 3em;
  border: solid 1px white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MailToLink = styled.a `
  text-decoration: none;
`

